import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IndexComponent} from "./index.component";
import {BannerModule} from "../../layouts/banner/banner.module";
import {NewsModule} from "../../components/news/news.module";
import {TruncatePipe} from "../../pipes/truncate.pipe";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DxPopupModule, DxButtonModule, DxTemplateModule } from 'devextreme-angular';
import {SafePipe} from "../../pipes/safe.pipe";
import {ChartsModule} from "../../components/charts/charts.module";


@NgModule({
  imports: [
    CommonModule, BannerModule, NewsModule, RouterModule,  FormsModule, ReactiveFormsModule,
    DxPopupModule,
    DxButtonModule,
    DxTemplateModule,
    ChartsModule
  ],
  declarations: [IndexComponent, TruncatePipe, SafePipe],
  exports: [IndexComponent]
})
export class IndexModule { }



// WEBPACK FOOTER //
// ./src/app/pages/index/index.module.ts